export default __webpack_public_path__ + "static/media/take-a-bow.cf6c5451.gif";